import { Menu, MenuItem, MenuItemLink } from "@progress/kendo-react-layout";
import React, { useEffect } from "react";
import routes from 'jsons/connected-routes.json';
import '../../scss/_menuHeader.scss';
import { Badge, BadgeContainer } from "@progress/kendo-react-indicators";
import Notification from "commons/notifications/Notification";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { enCours } from "constants/taskStatus";
import { getKeys } from "commons/helpers/NotificationHelper";
import PropTypes from 'prop-types';
import { useAppSelector } from "../../redux/store";
import { useGetTachesQuery, useLazyGetTachesUsagerQuery } from "../../redux/api/cache";
import { logout } from "../../redux/slices/appStateSlice";

export default function MenuHeader(props) {
    const user = useAppSelector(state => state.appState.user);
    const [sortedTasks, setSortedTasks] = useState([]);
    const dispatch = useDispatch();
    let headerRoutes = routes.filter(route => route.header);
    const navigate = useNavigate();
    const { data: task, isLoading, isFetching } = useGetTachesQuery({ usr_cd: user, filtre: 'usager' }, { skip: !user });
    const [getTaskUsager] = useLazyGetTachesUsagerQuery();

    useEffect(() => {
        const initializeTasks = async () => {
            const userTasks = [];
            if (!isFetching) {
                if (task?.data && task.data.length > 0) {
                    var promise = task.data.map(async d => {
                        return getTaskUsager({ tac_id: d.tac_id, usr_cd: user }, true);
                    });
                    var result = await Promise.all(promise);
                    result.forEach(r => {
                        if (r.data.success && r.data.data[0].tacusr_statut === enCours) {
                            userTasks.push(r.data.data[0].tac_id);
                        }
                    });
                    setSortedTasks(task?.data && task.data.length > 0 ? [...task.data].filter(d => userTasks.includes(d.tac_id)).sort((a, b) => a.tac_date.localeCompare(b.tac_date)) : []);
                }
                else
                    setSortedTasks([]);
            }
        };
        initializeTasks();
    }, [getTaskUsager, task, isFetching, user]);

    const getNotifsNumber = () => {
        var number = sortedTasks.length;
        return number > 9 ? "9+" : number;
    };

    const notifcationLinkRender = defaultProps => {
        return <MenuItemLink opened={defaultProps.opened}>
            <BadgeContainer><span className={`k-icon k-font-icon k-i-${defaultProps.item.icon}`} role="presentation" key="0" /><Badge size="small" rounded="full" themeColor={process.env.REACT_APP_ENV === 'dev' ? "primary" : "error"} > {getNotifsNumber()}</Badge></BadgeContainer>
        </MenuItemLink >;
    };
    const onSelect = async (event) => {
        if (event.item.data?.type === "logout") {
            navigate('/');
            dispatch(logout());
        }
    };

    const notificationWrapper = (defaultProps, keys, type) => {
        return (<Notification item={defaultProps.item.data} keys={keys} isRequis={type === "Requis"} />);
    };

    return <>
        <Menu onSelect={onSelect} openOnClick={true} className="k-d-flex k-justify-content-end k-h-full" style={{
            position: "fixed",
            top: "0", width: "100%", boxShadow: "0 0 10px rgb(0 0 0)", zIndex: '100', height: '50px', backgroundColor: process.env.REACT_APP_COLOR, cursor: "pointer"
        }}>
            {(!isLoading &&
                <MenuItem icon="notification" cssClass={`header-menu-item`} linkRender={notifcationLinkRender}>
                    {sortedTasks?.map((notification, i) => {
                        var keys = getKeys(notification.tac_key);
                        return (<MenuItem data={{ ...notification, type: "notification" }} url={notification.tac_type === 'Requis' ? `/#/Publicite/Calendrier-Gant/Projets/${keys.camp_seq}?media=${keys.media_cd}` : `/#/Publicite/Calendrier-Gant/Projets/${keys.camp_seq}?media=${keys.media_cd}&campagne=${keys.extraKey}&document=${keys.ridDoc}`} render={(defaultProps) => notificationWrapper(defaultProps, keys, notification.tac_type)} cssClass="notification-menu-item" cssStyle={{ border: "2px black solid" }} key={i} />);
                    }
                    )}
                </MenuItem>)}
            <MenuItem text="Mon compte" cssStyle={{ textAlign: "center", marginLeft: '1vw' }} cssClass={`header-menu-item`}>
                {headerRoutes.map((e, i) => (<MenuItem key={i} text={e.name} icon={e.icon} url={e.route} data={{ type: e.type }} cssClass="child-menu-item" />))}
            </MenuItem>
        </Menu>{props.children}
    </>;
}

MenuHeader.propTypes = {
    children: PropTypes.any
};